import { useState } from 'react';
import type { SessionStorageValue } from '@/shared/lib/storage';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

type OverrideValue = SessionStorageValue<'debug-billing-period-type-override'>;

/**
 * 契約期間タイプ（billing_period_type）のオーバーライドを管理するフック
 *
 * yearly プランの表示を monthly テナントでも確認できるようにするためのデバッグ用機能。
 * セッションストレージに状態を保存する。
 */
export const useBillingPeriodTypeOverride = () => {
  const [overrideValue, setOverrideValue] = useState<OverrideValue>(() =>
    getSessionStorage('debug-billing-period-type-override'),
  );

  const updateOverrideValue = (value: OverrideValue) => {
    setOverrideValue(value);
    setSessionStorage('debug-billing-period-type-override', value);
  };

  return {
    overrideValue,
    updateOverrideValue,
  };
};
